import { routes } from "./router";
import type { ModuleInitialise } from "@/types";

export const initialiseModule: ModuleInitialise = ({ router }) => {
  routes.map((route) => router.addRoute(route));
};

export * from "./api";
export * from "./helpers";
export * from "./types";
